import classNames from 'classnames';
import React from 'react';

interface AttributeTableProps {
  noTitle?: boolean;
  children: React.ReactNode;
}

const AttributeTable: React.FC<AttributeTableProps> = ({
  noTitle,
  children,
}) => {
  return (
    <div
      className={classNames('attribute__table', {
        'attribute__table--no-title': noTitle,
      })}
    >
      {children}
    </div>
  );
};

export default AttributeTable;
